<template>
  <TableLineWrapper :isBottomBinvoiceNotShow="index === rowLength - 1">
    <TableInfoLine :value="String(invoice.docId)" />
    <TableInfoLine :value="formatDate(invoice.curdate)" />
    <TableInfoLine :value="formatDate(invoice.duedate)" />
    <TableInfoLine>
      <StatusLabel :status="invoice.Status.statusname"
    /></TableInfoLine>
    <TableInfoLine :value="'₪' + invoice.totalprice.toLocaleString()" />
    <TableActions mode="invoices" :document="invoice" />
  </TableLineWrapper>
</template>

<script>
import moment from "moment";
import TableInfoLine from "../../../UI/tabels/TableInfoLine.vue";
import TableLineWrapper from "../../../UI/tabels/TableLineWrapper.vue";
import StatusLabel from "../../../UI/tabels/StatusLabel.vue";
import TableActions from "../../../UI/tabels/TableActions.vue";
export default {
  components: { TableInfoLine, TableLineWrapper, StatusLabel, TableActions },
  props: {
    invoice: {
      type: Object,
    },
    rowLength: {
      type: Number,
    },
    index: {
      type: Number,
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped lang="scss"></style>
